<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <el-pagination
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
    >
      <el-table-column
        v-for="data in columnList"
        :key="data.type"
        :prop="data.type"
        :label="$t(`table.${data.type}`)"
        v-bind="data.custom"
      >
        <template #default="{ row }">
          <img
            v-if="data.type.includes('img')"
            :key="row[data.type]"
            :src="row[data.type]"
            class="table-img"
          >
          <div v-else-if="data.type === 'member'">
            {{ row.mid }}
            <br>
            {{ row.uniquename }}
          </div>
          <div v-else>
            {{ row[data.type] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'
import PostService from '../../api/posts'

// configs for the columns of the post list
const columnList = [
  { type: 'id', custom: { width: '64' } },
  { type: 'mainimg', custom: { width: '120' } },
  { type: 'member', custom: { width: '120' } },
  { type: 'enable', custom: { width: '60' } },
  { type: 'message', custom: { 'min-width': '120' } },
  { type: 'number_of_likes', custom: { width: '50' } },
  { type: 'number_of_comments', custom: { width: '84' } },
  { type: 'create_date', custom: { width: '135' } },
  { type: 'goxip_post_type', custom: { width: '50' } },
]

export default {
  name: 'PostList',
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      columnList,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.isLoading = true
      try {
        const response = await PostService.getList(this.listQuery.page, this.listQuery.size)
        const { data: newList, pagination } = response
        this.list = newList.map(item => ({
          ...item,
          enable: item.isEnable === '0' ? this.$t('common.no') : this.$t('common.yes'),
        }))
        this.listQuery.total = parseInt(pagination.total_items, 0)
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
